import { ItasMinusIcon, ItasPlusIcon, RightArrowIcon } from "src/assets";
import { lowerLanguage } from "src/i18n";
import { Faq } from "src/types";
import LandingAccordion from "src/ui/fragments/landing-accordion/Accordion";
import { Button } from "src/ui/widgets";

import { useSection7 } from "./section7.hook";

export const Section7 = () => {
  const { t, faqs, numberOfFaqToShow, goToFaqs } = useSection7();

  const Title = (
    <h3 className="mb-4 section7-dynamic-size-title d-flex align-item-center text-uppercase">
      {t("landing.section_7_title")}
    </h3>
  );

  const Subtitle = (
    <div className="mb-4 section7-dynamic-size-subtitle d-flex align-items-center white-space-pre-subtitle">
      {t("landing.section_7_subtitle")}
    </div>
  );

  const ButtonForm = (
    <div className="mb-5">
      <Button
        text={t("landing.section_7_all_faqs")}
        iconRight={RightArrowIcon}
        iconSize={18}
        classes="primary"
        onPress={goToFaqs}
      />
    </div>
  );

  const Faqs = (
    <div className="pt-4 pt-md-0 ">
      <div>
        {faqs?.slice(0, numberOfFaqToShow).map((item: Faq) => {
          return (
            <LandingAccordion
              key={item?.faqCode}
              title={item?.request?.[lowerLanguage]}
              classes_title="m-0 p-0 me-3 section7-dynamic-size-faq-title col-8"
              icon_size={24}
              icon_open={ItasMinusIcon}
              icon_close={ItasPlusIcon}
              button_read={false}
              show_close={true}
              classes="pe-md-3 section7-class"
              classes_icon_open="section7-open-icon filter-00686F"
              classes_icon_close="filter-00686F"
              separator="section7-separator"
            >
              <div
                className="py-2 landing-dynamic-size-desc px-0 white-space-pre mb-5"
                dangerouslySetInnerHTML={{
                  __html: item?.answer?.[lowerLanguage] || "",
                }}
              />
            </LandingAccordion>
          );
        })}
      </div>
    </div>
  );

  return (
    <div className="col-xl-12 d-xl-flex justify-content-center">
      <div className="col-xl-6 mb-5">
        {Title}
        {Subtitle}
        {ButtonForm}
      </div>
      <div className="pt-2 col-xl-6">{Faqs}</div>
    </div>
  );
};
